import { Space, Table } from "antd";
import { Nota } from "../../../../../Models/Financeiro/Titulo/Nota";
import { TableProps } from "antd/lib/table";
import Utilitario from "../../../../../Utils/Utilitario";
import { EnumNotaSituacao } from "../../../../../Models/Financeiro/Titulo/Nota/NotaSituacao";
import NotaEmitirFormModal from "./NotaEmitirFormModal";
import NotaCancelamentoPopconfirm from "./NotaCancelamentoPopconfirm";
import ComponentePermissao from "../../../../Base/Permissao/ComponentePermissao";
import { PermissoesKey } from "../../../../../Constants/Permissoes";
import { EnumPessoaTipo } from "../../../../../Models/Pessoa/Pessoa";
import NotaFormModal from "./NotaFormModal";

interface INotaTableProps extends TableProps<Nota> {
    isGerar?:boolean;
    isCancelar?:boolean;
    onReFetch?:() => void;
}
export default function NotaTable({
    isGerar,
    isCancelar,
    loading,
    dataSource,
    onReFetch,
    ...rest
}:INotaTableProps) {
    isGerar = isGerar ?? false;
    isCancelar = isCancelar ?? false;

    return <Table<Nota>
        {...rest}
        loading={loading}
        style={{
            overflowX : "auto"
        }}
        dataSource={dataSource}
        rowKey={(item) => item.codTitulo}
        columns={[
            {
                dataIndex : ["codTitulo"],
                title : "Título",
                key : "codTitulo",
                render: (value: string) => (value ?? "").length == 0 ? " - " : value
            },
            {
                dataIndex : ["dataCompetencia"],
                title : "Competência",
                key : "dataCompetencia",
                render: (value: Date) => value.toLocaleDateString(),
            },
            {
                dataIndex : ["prestador", "nomeExibicao"],
                title : "Prestador",
                key : "prestador"
            },
            {
                dataIndex : ["tomador", "nomeExibicao"],
                title : "Tomador",
                key : "tomador"
            },
            {
                dataIndex : "valor",
                title : "Valor (R$)",
                key : "valor",
                render(value, record, index) {
                    return Utilitario.toStringDinheiro(value);
                },
            },
            {
                dataIndex : "numero",
                title : "Nota",
                key : "numero",
                render: (value: string, record:Nota) => (value ?? "").length == 0 ? " - " : <a rel="noopener" href={record.url!} target="_blank">{value}</a>
            },
            {
                dataIndex : "numeroRps",
                title : "Rps",
                key : "numeroRps",
                render: (value: string) => (value ?? "").length == 0 ? " - " : value
            },
            {
                dataIndex : "serieRps",
                title : "Série Rps",
                key : "serieRps",
                render: (value: string) => (value ?? "").length == 0 ? " - " : value
            },
            {
                dataIndex : ["situacao", "nome"],
                title : "Situação",
                key : "situacao"
            },
            {
                title: "Ações",
                key: "acoes",
                render: (_, nota) => <Space size="small" wrap>
                    <NotaFormModal nota={nota} onSuccess={onReFetch} />
                    {
                        nota.prestador.tipo == EnumPessoaTipo.EMPRESA && <>
                            {isGerar && EnumNotaSituacao.Pendente == nota.codSituacao && <NotaEmitirFormModal nota={nota} onSuccess={onReFetch} />}
                            {isCancelar && nota.codigo > 0 && EnumNotaSituacao.Emitida == nota.codSituacao && <NotaCancelamentoPopconfirm nota={nota} onSuccess={onReFetch} />}
                        </>
                        // || <>
                        //     {isGerar && <NotaFormModal nota={nota} onSuccess={onReFetch} />}
                        // </>
                    }
                </Space>
            }
        ]}
    />
}